import { isNullOrWhiteSpace } from 'data/string';
import template from './OauthFormView.html';
class OauthFormController {
    static $inject = ['$translate', '$scope', 'MessagingHubService', 'SegmentService'];
    constructor($translate, $scope, MessagingHubService, SegmentService) {
        'ngInject';
        this.$translate = $translate;
        this.$scope = $scope;
        this.MessagingHubService = MessagingHubService;
        this.SegmentService = SegmentService;
        this.oAuthGrantType = 'client_credentials';
        this.errorInputForm = {
            errorMessagesUrl: '',
            errorNotificationsUrl: '',
            errorOauthAuthorizationServerUri: '',
            errorOAuthClientId: '',
            errorClientSecret: '',
        };
        this.loaded = false;
        this.changeSensitiveData = false;
        this.sensitiveData = '**********';
        this.onSave = async () => {
            if (!this.url || !this.validations.isValidHttpForm) {
                console.warn('Invalid form');
                return;
            }
            const commandResponse = await this.MessagingHubService.processCommand({
                method: 'set',
                to: 'postmaster@analytics.msging.net',
                uri: `/providers/oauth-configuration/${encodeURIComponent(this.url)}`,
                type: 'application/vnd.iris.analytics.webhook-oauth-configuration+json',
                resource: {
                    webhookUri: this.url,
                    authorizationServerUri: this.oAuthAuthorizationServerUri,
                    grantType: this.oAuthGrantType,
                    clientId: this.oAuthClientId,
                    clientSecret: this.changeSensitiveData ? this.oAuthClientSecret : undefined,
                },
            });
            if (this.changeSensitiveData) {
                this.oAuthClientSecret = this.sensitiveData;
                this.enabledComponentClientSecret(true, false);
            }
            this.changeSensitiveData = false;
            this.MessagingHubService.ensureCommandSuccess(commandResponse);
            this.$scope.$apply();
        };
        this.onClick = async () => {
            if (!this.loaded) {
                this.loaded = true;
                await this.onLoad();
            }
        };
        this.onLoad = async () => {
            if (!this.url) {
                return;
            }
            this.changeSensitiveData = true;
            const commandResponse = await this.MessagingHubService.processCommand({
                method: 'get',
                to: 'postmaster@analytics.msging.net',
                uri: `/providers/oauth-configuration/${encodeURIComponent(this.url)}`,
            });
            const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
            this.url = resource.webhookUri;
            this.oAuthAuthorizationServerUri = resource.authorizationServerUri;
            this.oAuthGrantType = resource.grantType;
            this.oAuthClientId = resource.clientId;
            this.oAuthClientSecret = resource.clientSecret;
            this.changeSensitiveData = isNullOrWhiteSpace(this.oAuthClientSecret) && isNullOrWhiteSpace(this.oAuthClientId);
            if (!isNullOrWhiteSpace(resource.clientSecret) || resource.hidingOAuthSecret) {
                this.oAuthClientSecret = this.sensitiveData;
            }
            this.enabledComponentClientSecret(true, false);
        };
        this.onChangeOAuthAuthorizationServerUri = (event) => {
            const { detail: { value } } = event;
            this.oAuthAuthorizationServerUri = value;
        };
        this.onChangeOAuthGrantType = (event) => {
            const { detail: { value } } = event;
            this.oAuthGrantType = value;
        };
        this.onChangeOAuthClientId = (event) => {
            const { detail: { value } } = event;
            this.oAuthClientId = value;
        };
        this.onChangeClientSecret = (event) => {
            const { detail: { value } } = event;
            this.oAuthClientSecret = value;
        };
        this.editClientSecret = () => {
            const clientSecret = document.getElementById(`oAuthClientSecret-${this.index}`);
            this.enabledComponentClientSecret(false, true);
            clientSecret.removeAttribute('disabled');
            this.oldOAuthClientSecret = this.oAuthClientSecret;
            this.oAuthClientSecret = '';
        };
        this.saveClientSecret = () => {
            this.enabledComponentClientSecret(true, false);
            this.oldOAuthClientSecret = this.oAuthClientSecret;
            this.changeSensitiveData = true;
        };
        this.cancelClientSecret = () => {
            this.oAuthClientSecret = this.oldOAuthClientSecret;
            this.oldOAuthClientSecret = '';
            this.enabledComponentClientSecret(true, false);
            this.showMessages();
        };
        this.enabledComponentClientSecret = (enable, blockField) => {
            const saveClientSecret = document.getElementById(`saveClientSecret-${this.index}`);
            const cancelClientSecret = document.getElementById(`cancelClientSecret-${this.index}`);
            const editClientSecret = document.getElementById(`editClientSecret-${this.index}`);
            const clientSecret = document.getElementById(`oAuthClientSecret-${this.index}`);
            const urlIntegration = document.getElementById(`url-integration-${this.index}`);
            const addUrl = document.getElementById('add-url');
            const saveWebHook = document.getElementById('save-webhook');
            saveClientSecret.hidden = enable;
            cancelClientSecret.hidden = enable;
            editClientSecret.hidden = isNullOrWhiteSpace(this.oAuthClientSecret) || !enable;
            clientSecret.setAttribute('disabled', !editClientSecret.hidden ? 'true' : 'false');
            clientSecret.setAttribute('open-eyes', 'false');
            urlIntegration.setAttribute('disabled', blockField ? 'true' : 'false');
            saveWebHook.setAttribute('disabled', 'true');
            addUrl.setAttribute('disabled', 'true');
            if (!blockField) {
                addUrl.removeAttribute('disabled');
                saveWebHook.removeAttribute('disabled');
            }
        };
        this.showMessages = () => {
            const errorClientID = this.errorOAuthClientId;
            const errorClientSecret = this.errorClientSecret;
            const errorMsg = this.apiFieldErrorMessages;
            this.errorInputForm.errorOauthAuthorizationServerUri = '';
            this.errorInputForm.errorOAuthClientId = '';
            this.errorInputForm.errorClientSecret = '';
            this.validateHttpFormState();
            if (!this.validations.isOauthAuthorizationServerUriValid) {
                this.errorInputForm.errorOauthAuthorizationServerUri = errorMsg;
            }
            if (!this.validations.isOAuthClientIdValid) {
                this.errorInputForm.errorOAuthClientId = errorClientID;
            }
            if (!this.validations.isClientSecretValid) {
                this.errorInputForm.errorClientSecret = errorClientSecret;
            }
        };
        this.onBlurVerifyOAuth = (_) => {
            this.showMessages();
        };
        this.$onInit();
    }
    async $onInit() {
        this.validations = new HttpValidations();
        this.errorInputForm.errorMessagesUrl = '';
        this.errorInputForm.errorNotificationsUrl = '';
        this.errorInputForm.errorOauthAuthorizationServerUri = '';
        this.errorInputForm.errorOAuthClientId = '';
        this.errorInputForm.errorClientSecret = '';
        this.apiFieldErrorMessages = this.$translate.instant('apiValues.errors.invalidNetworkAddress');
        this.errorOAuthClientId = this.$translate.instant('apiValues.errors.errorOAuthClientId');
        this.errorClientSecret = this.$translate.instant('apiValues.errors.errorClientSecret');
        this.$scope.$on('save', this.onSave);
        await this.onLoad();
    }
    integrationsAuthorizationInput() {
        this.SegmentService.createApplicationTrack({
            trackEvent: 'integrations-webhook-settings-oauth-url-authorization-input',
        });
    }
    integrationsClientIdInput() {
        this.SegmentService.createApplicationTrack({
            trackEvent: 'integrations-webhook-settings-oauth-client-id-input',
        });
    }
    integrationsClientSecretInput() {
        this.SegmentService.createApplicationTrack({
            trackEvent: 'integrations-webhook-settings-oauth-client-secret-input',
        });
    }
    async deleteOauth() {
        this.oAuthAuthorizationServerUri = '';
        this.oAuthClientId = '';
        this.oAuthClientSecret = '';
        this.oldOAuthClientSecret = '';
        this.errorInputForm.errorOAuthClientId = '';
        this.errorInputForm.errorClientSecret = '';
        this.validateHttpFormState();
        this.enabledComponentClientSecret(true, false);
    }
    validateHttpFormState() {
        this.validations.validateOAuthState(this.oAuthAuthorizationServerUri, this.oAuthClientId, this.oAuthClientSecret);
    }
}
OauthFormController.$inject = ['$translate', '$scope', 'MessagingHubService', 'SegmentService'];
class HttpValidations {
    get isValidHttpForm() {
        return this.isOauthAuthorizationServerUriValid && this.isOAuthClientIdValid && this.isClientSecretValid
            && this.isOAuthClientIdValid && this.isOAuthValidState;
    }
    constructor() {
        this.isOauthAuthorizationServerUriValid = true;
        this.isOAuthClientIdValid = true;
        this.isClientSecretValid = true;
        this.isOAuthValidState = false;
    }
    validateOAuthState(oAuthAuthorizationServerUri, oAuthClientId, oAuthClientSecret) {
        this.isOauthAuthorizationServerUriValid = true;
        this.isOAuthClientIdValid = true;
        this.isClientSecretValid = true;
        this.isOAuthValidState = !isNullOrWhiteSpace(oAuthAuthorizationServerUri)
            || !isNullOrWhiteSpace(oAuthClientId)
            || !isNullOrWhiteSpace(oAuthClientSecret);
        if (this.isOAuthValidState && !this.isWebSite(oAuthAuthorizationServerUri)) {
            this.isOauthAuthorizationServerUriValid = false;
        }
        if (this.isOAuthValidState && !oAuthClientId) {
            this.isOAuthClientIdValid = false;
        }
        if (this.isOAuthValidState && !oAuthClientSecret) {
            this.isClientSecretValid = false;
        }
    }
    isWebSite(website) {
        const urlPattern = /^(https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
        return urlPattern.test(String(website).toLowerCase());
    }
}
export const OauthFormComponent = {
    template,
    controller: OauthFormController,
    controllerAs: '$ctrl',
    bindings: {
        url: '@',
        index: '@',
    },
};
